export default "__VITE_ASSET__DwjSOP1h__"